module.exports = __webpack_public_path__ + "img/phone-white.70d9f0b4.svg";